import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Grid, makeStyles } from '@material-ui/core';

import { trustedLoginRequest } from 'modules/authenticate/actions';
import { AuthenticateData } from 'modules/authenticate/interfaces';

import { history } from 'store';
import useQuery from 'hooks/useQuery';
import { superUser } from 'utils/helpers';
import Loading from 'components/Loading';

import styles from './styles';

interface Props {
  data: AuthenticateData;
  trustedLoginRequest: (token: string) => void;
}

const TrustedLogin: React.FC<Props> = ({ data, trustedLoginRequest }) => {
  const classes = makeStyles(styles)();
  const query = useQuery();

  const token = query.get('token');

  useEffect(() => {
    if (token) {
      trustedLoginRequest(token);
    }
  }, [token, trustedLoginRequest]);

  useEffect(() => {
    if (data?.token && !data?.mfa?.required) {
      const URL = superUser(data?.role)
        ? '/all-environments'
        : '/dashboard/partner';
      history.replace(URL);
    }
  }, [data]);

  return (
    <Grid className={classes.root}>
      <Loading />
    </Grid>
  );
};

const mapStateToProps = ({ authenticate }) => ({
  data: authenticate.data,
});

export default connect(mapStateToProps, { trustedLoginRequest })(TrustedLogin);
